import { render, staticRenderFns } from "./otorisasi.vue?vue&type=template&id=29373ff3&scoped=true&"
import script from "./otorisasi.vue?vue&type=script&lang=js&"
export * from "./otorisasi.vue?vue&type=script&lang=js&"
import style0 from "./otorisasi.vue?vue&type=style&index=0&id=29373ff3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29373ff3",
  null
  
)

export default component.exports